/*
* Виджет CloudPayments приходит скриптом на страницу (см. public/index.html) и живёт в
* глобальной `cp`. Типов у него нет — описываем ровно то, чем пользуемся, чтобы в фиче
* не было `any` и `@ts-ignore`.
* */
interface CloudPaymentsPayOptions {
    publicId: string;
    description: string;
    amount: number;
    currency: string;
    invoiceId: string;
    skin: string;
}

interface CloudPaymentsCallbacks {
    onSuccess: () => void;
    onFail: () => void;
    onComplete: () => void;
}

interface CloudPaymentsWidget {
    pay: (
        type: "auth" | "charge",
        options: CloudPaymentsPayOptions,
        callbacks: CloudPaymentsCallbacks
    ) => void;
}

interface CloudPaymentsApi {
    CloudPayments: new (options: { language: string }) => CloudPaymentsWidget;
}

export const openCloudPaymentsWidget = (
    options: CloudPaymentsPayOptions,
    callbacks: CloudPaymentsCallbacks
): boolean => {
    const api = (window as unknown as { cp?: CloudPaymentsApi }).cp;

    if (!api) return false;

    // 'auth' — двухстадийная оплата: списание подтверждает бэк по вебхуку.
    new api.CloudPayments({ language: "ru-RU" }).pay("auth", options, callbacks);

    return true;
};
